
module.exports = {
    pointIdToPath: (flatTree, id) => {
        //get data in tree store
        if (!flatTree || !flatTree.length) return '';
        var point = flatTree.find(
            (x) => x._id == id
        );
        var path = [];
        while (point) {
            path.push(point);
            point = flatTree.find((x) => x._id == point.parent && x._id != 'root');
        }
        return path
            .map((x) => x.name)
            .reverse()
            .join(" > ");
    }
};